import { createContext, ReactNode, useState } from "react";

export type NavContextData = {
    sidebarSelectedNavValue: string | null,
    subPageNavValue: string | null
};

export interface NavContextInterface {
    navData: NavContextData,
    setNavData: React.Dispatch<React.SetStateAction<NavContextData>>
}

export const NavContext = createContext<NavContextInterface>({} as NavContextInterface);

export default function NavContextProvider(
    {
        children
    }: {
        children: ReactNode
    }
) {
    const [ navData, setNavData ] = useState<NavContextData>({
        sidebarSelectedNavValue: null,
        subPageNavValue: null
    });

    return (
        <NavContext.Provider value={{
            navData,
            setNavData
        }}>
            {children}
        </NavContext.Provider>
    );
}